import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import ChimneyCleaningPage from '../pages/services/chimney-cleaning/page';
import AirDuctCleaningPage from '../pages/services/air-duct-cleaning/page';
import DryerVentCleaningPage from '../pages/services/dryer-vent-cleaning/page';
import ReviewsPage from '../pages/reviews/page';
import FAQPage from '../pages/faq/page';
import ContactPage from '../pages/contact/page';
import ServiceAreasPage from '../pages/service-areas/page';
import ProcessPage from '../pages/process/page';
import GalleryPage from '../pages/gallery/page';
import BlogPage from '../pages/blog/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/services/chimney-cleaning', element: <ChimneyCleaningPage /> },
  { path: '/services/air-duct-cleaning', element: <AirDuctCleaningPage /> },
  { path: '/services/dryer-vent-cleaning', element: <DryerVentCleaningPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/service-areas', element: <ServiceAreasPage /> },
  { path: '/process', element: <ProcessPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
